import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "w-full" };
const _hoisted_2 = { class: "pii-price" };
const _hoisted_3 = { class: "line" };
const _hoisted_4 = { class: "line" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { class: "line" };
const _hoisted_8 = ["href"];
const _hoisted_9 = { class: "pii-list" };
const _hoisted_10 = { class: "pii-progress" };
const _hoisted_11 = {
    class: "d-flex flex-column align-items-end",
    style: { "text-align": "right" }
};
const _hoisted_12 = { class: "d-flex flex-column" };
const _hoisted_13 = { class: "pii-enter" };
const _hoisted_14 = { class: "flex justify-between gap-2 mb-2 w-full" };
const _hoisted_15 = {
    key: 0,
    class: "error"
};
import BigNumber from "bignumber.js";
import ProjectInvestModal from "@/components/uikit/platformComponents/ProjectInvestModal.vue";
import UList from "@/components/uikit/uComponents/UList.vue";
import UListItem from "@/components/uikit/uComponents/UListItem.vue";
import { computed, ref } from "vue";
import { getCurrentPercent, getDatesToEnd } from "@/components/capital/projectHelper";
import { useI18n } from "@/localization/localizator";
import { useStore } from "vuex";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProjectInvestInfo',
    props: {
        createdAddress: {
            type: String,
            default: ""
        },
        priceBase: {
            type: String,
            default: ""
        },
        mnemonicDecimals: {
            type: String,
            default: ""
        },
        minCount: {
            type: String,
            default: ""
        }
    },
    setup(__props) {
        const t = useI18n();
        const showDialog = ref(false);
        const props = __props;
        const store = useStore();
        const project = computed(() => store.getters["capitals/auCapital"]);
        const defaultCurrency = computed(() => process.env.VUE_APP_CURRENCY_DEFAULT);
        const owner = computed(() => store.getters["owner/auOwners"].find((item) => item.auToken.id == project.value.tokenQuote?.id));
        const isAutentic = process.env.VUE_APP_PLATFORM == "Autentic";
        const datesDiff = computed(() => getDatesToEnd(project.value.dateEnd));
        const scanBaseUrl = computed(() => process.env.VUE_APP_SCAN_BASE_URL);
        const tokenIcon = computed(() => project.value.tokenQuote?.logoMain ?? "/svg/companies/s_logo.svg");
        const scannerTokenLink = computed(() => `${scanBaseUrl.value}token/${project.value.tokenBase?.createdAddress}`);
        const scannerUrl = computed(() => `${scanBaseUrl.value}contract/${project.value.smartContract?.ethAddress.value}`);
        const percent = computed(() => getCurrentPercent(project.value));
        const items = computed(() => [
            {
                label: "Expert approvals",
                value: `${project.value.minExpertVotes} / ${project.value.expertVotes}`,
                visible: project.value.expertVotes != 0
            },
            {
                type: "address",
                label: "Contract address",
                value: project.value.smartContract.ethAddress.value,
                url: scannerUrl.value
            },
            {
                type: "address",
                label: "Token address",
                value: project.value.tokenBase?.createdAddress,
                url: scannerTokenLink.value
            },
            { label: "Token type", value: t("projects.commonStock") },
            {
                label: "Allocation frequency",
                value: "Monthly",
                tooltip: "Lorem ipsum dolor sit amet consectetur",
                visible: isAutentic
            },
            {
                label: "Projected annual proceeds",
                value: project.value.expectedProfit + "%"
            },
            {
                type: "decimals",
                label: "System comission",
                token: {
                    value: project.value.feePercent,
                    decimals: 2,
                    indent: 0,
                    visualIndent: false,
                    addition: "%"
                }
            },
            {
                label: "Required user level",
                value: project.value.userLimitStatuses
            },
            {
                styleType: "green",
                label: "Close in",
                value: datesDiff.value + " days"
            }
        ]);
        const minQuote = computed(() => {
            const price = BigNumber(props.priceBase).dividedBy(BigNumber(10).pow(props.mnemonicDecimals));
            const value = BigNumber(props.minCount).multipliedBy(price);
            return value.isNaN() ? "0" : value.toString(10);
        });
        const logoIcon = computed(() => project.value.tokenBase?.mainImage?.name || "/svg/companies/s_logo.svg");
        return (_ctx, _cache) => {
            const _component_UIcon = _resolveComponent("UIcon");
            const _component_UDecimal = _resolveComponent("UDecimal");
            const _component_UProgressBar = _resolveComponent("UProgressBar");
            const _component_UButton = _resolveComponent("UButton");
            const _component_UInput = _resolveComponent("UInput");
            const _component_UContent = _resolveComponent("UContent");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_UContent, {
                        "has-title-delimiter": false,
                        class: "flex-1"
                    }, {
                        header: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(project.value.nameEng), 1)
                        ]),
                        content: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                    _createVNode(_component_UIcon, { icon: "/img/capital/price_tag.svg" }),
                                    _cache[2] || (_cache[2] = _createElementVNode("span", null, "Token price –", -1)),
                                    _createVNode(_component_UIcon, { icon: tokenIcon.value }, null, 8, ["icon"]),
                                    _createVNode(_component_UDecimal, {
                                        value: 1,
                                        decimals: 2,
                                        indent: 2,
                                        "show-addition": false
                                    })
                                ]),
                                _createElementVNode("div", _hoisted_4, [
                                    _createVNode(_component_UIcon, { icon: "/img/capital/profit.svg" }),
                                    _cache[3] || (_cache[3] = _createElementVNode("span", null, "Minimum participation amount –", -1)),
                                    _createVNode(_component_UIcon, { icon: tokenIcon.value }, null, 8, ["icon"]),
                                    (minQuote.value && minQuote.value != '0')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                            _createVNode(_component_UDecimal, {
                                                value: minQuote.value,
                                                decimals: 2,
                                                indent: 2,
                                                "show-addition": false
                                            }, null, 8, ["value"])
                                        ]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                                            _createVNode(_component_UDecimal, {
                                                value: 2,
                                                decimals: 2,
                                                indent: 2,
                                                "show-addition": false
                                            })
                                        ]))
                                ]),
                                _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_component_UIcon, {
                                        class: "logo-icon",
                                        icon: logoIcon.value
                                    }, null, 8, ["icon"]),
                                    _createElementVNode("span", null, [
                                        _createElementVNode("a", {
                                            href: scannerTokenLink.value,
                                            target: "_blank"
                                        }, _toDisplayString(project.value.tokenBase.mnemonicEng), 9, _hoisted_8)
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                                _createVNode(UList, {
                                    "flex-direction": "column",
                                    gap: "10px",
                                    width: "100vw"
                                }, {
                                    default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
                                            return (_openBlock(), _createBlock(UListItem, _mergeProps({ key: index }, { ref_for: true }, item), null, 16));
                                        }), 128))
                                    ]),
                                    _: 1
                                })
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _createVNode(_component_UProgressBar, {
                                    procent: percent.value,
                                    green: ""
                                }, {
                                    "top-left": _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                            _createElementVNode("span", null, null, -1)
                                        ]))]),
                                    "top-right": _withCtx(() => [
                                        _createElementVNode("div", _hoisted_11, [
                                            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "label" }, " Hard cap ", -1)),
                                            _createVNode(_component_UDecimal, {
                                                value: project.value.maxCap,
                                                decimals: 2,
                                                indent: 2,
                                                addition: defaultCurrency.value,
                                                "show-addition": true
                                            }, null, 8, ["value", "addition"])
                                        ])
                                    ]),
                                    "bottom-left": _withCtx(() => [
                                        _createElementVNode("div", _hoisted_12, [
                                            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "label" }, " Amount raised ", -1)),
                                            _createVNode(_component_UDecimal, {
                                                value: project.value.currentCap,
                                                decimals: 2,
                                                indent: 2,
                                                addition: defaultCurrency.value,
                                                "show-addition": true
                                            }, null, 8, ["value", "addition"])
                                        ])
                                    ]),
                                    "bottom-right": _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                            _createElementVNode("span", null, null, -1)
                                        ]))]),
                                    _: 1
                                }, 8, ["procent"])
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                    _createVNode(_component_UButton, {
                                        class: "flex-1",
                                        severity: "secondary"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_UIcon, {
                                                class: "logo-icon",
                                                icon: tokenIcon.value
                                            }, null, 8, ["icon"]),
                                            _cache[8] || (_cache[8] = _createTextVNode(" 1 ", -1))
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_UButton, {
                                        class: "flex-1",
                                        severity: "secondary"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_UIcon, {
                                                class: "logo-icon",
                                                icon: tokenIcon.value
                                            }, null, 8, ["icon"]),
                                            _cache[9] || (_cache[9] = _createTextVNode(" 100 ", -1))
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_UButton, {
                                        class: "flex-1",
                                        severity: "secondary"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_UIcon, {
                                                class: "logo-icon",
                                                icon: tokenIcon.value
                                            }, null, 8, ["icon"]),
                                            _cache[10] || (_cache[10] = _createTextVNode(" 500 ", -1))
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _createVNode(_component_UInput, { placeholder: "Enter token amount" })
                            ]),
                            _createVNode(_component_UButton, {
                                disabled: percent.value >= 100,
                                onClick: _cache[0] || (_cache[0] = ($event) => (showDialog.value = true))
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_UIcon, {
                                        class: "logo-icon bright",
                                        icon: tokenIcon.value
                                    }, null, 8, ["icon"]),
                                    _cache[11] || (_cache[11] = _createTextVNode(" Acquire token ", -1))
                                ]),
                                _: 1
                            }, 8, ["disabled"]),
                            (!owner.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Connect your wallet "))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    })
                ]),
                (showDialog.value)
                    ? (_openBlock(), _createBlock(ProjectInvestModal, {
                        key: 0,
                        modelValue: showDialog.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((showDialog).value = $event))
                    }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
